import * as dot from 'dot';

interface RedirectAction {
    action: `redirect`;
    url: string;
}

type AfterSuccessActionOptions = RedirectAction;

const actions = {
    redirect: (config: AfterSuccessActionOptions, info: any) => {
        const redirectTemplate = dot.template(config.url);
        window.location.href = redirectTemplate(info);
    },
};

const afterSuccessAction = (config: AfterSuccessActionOptions, info: any) => {
    const action = actions[config.action];

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!action) {
        throw new Error(`Missing action "${config.action}".`);
    }

    action(config, info);
};

export { type AfterSuccessActionOptions, afterSuccessAction };
